export default __webpack_public_path__ + "static/media/techblog3-fig3-3.b46fe970.png";